import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { style } from './style';

type HistoryCounterProps = {
  counter: number,
}
export const HistoryCounter = ({
  counter,
}: HistoryCounterProps):JSX.Element => {
  const { t: translate } = useTranslation();
  
  return (
    <Typography variant={ style.typography.variant }
      sx={ style.typography.sx }
      color={ style.typography.color }
    >
      { translate(STRING_KEYS.COUNTER_ACTIVITIES,
        { counter })}
    </Typography>
  );
};
